import type {AxiosError} from "axios";

function isAxiosError(error: unknown): error is AxiosError {
  return Boolean(error && typeof error === "object" && "isAxiosError" in error);
}

function resolveUnderlyingAxiosError(error: unknown): AxiosError | null {
  if (isAxiosError(error)) return error;

  if (error && typeof error === "object" && "cause" in error) {
    const cause = (error as {cause?: unknown}).cause;
    if (isAxiosError(cause)) return cause;
  }

  return null;
}

/** Axios failures are owned by the interceptor; never double-report from ErrorBoundary. */
export function shouldCaptureBoundaryError(error: unknown): boolean {
  const axiosError = resolveUnderlyingAxiosError(error);
  if (axiosError) {
    const status = axiosError.response?.status;
    if (status === 401 || status === 403 || status === 404 || status === 422) {
      return false;
    }
    return false;
  }

  if (!error) return true;

  const name = error instanceof Error ? error.name : "";
  const message = (
    error instanceof Error ? error.message : typeof error === "string" ? error : ""
  ).toLowerCase();

  if (name === "NotAllowedError") return false;
  if (message.includes("permission denied") || message.includes("permission dismissed")) {
    return false;
  }
  if (message.includes("notallowederror")) return false;

  return true;
}
